// Step 3 tags are compared ignoring case, surrounding spaces and repeated spaces (§11.9).
export const normalizeTag = (value) => String(value).trim().replace(/\s+/g, " ").toLowerCase()
